export default "__VITE_ASSET__vKCErLDu__"